<template>
  <div>
    <h4 class="content-block">Daftar Gaji</h4>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi>
            <DxDataGrid
              ref="gridRefDireksi"
              id="gridTDireksi"
              :data-source="dataSourceDireksi"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDireksi')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem name="exportButton" />
              </DxToolbar>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
              />
              <DxColumn
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
              >
              </DxColumn>

              <DxColumn data-field="riwayatGolongan.golongan_id" caption="Gol.">
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="pegawai.status_ptkp"
                caption="Status PTKP"
              />
              <DxColumn
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatPekerjaan.seksi_id" caption="Seksi">
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" />
              <DxColumn
                data-field="pot_5_persen"
                caption="Pot. 5 Persen"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_pensiun"
                caption="Pot. Pensiun Jiwasraya"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
              />
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
            </DxDataGrid>
          </template>
          <template #tTetap>
            <DxDataGrid
              ref="gridRefTetap"
              id="gridTetap"
              :data-source="dataSourceTetap"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefTetap')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem name="exportButton" />
              </DxToolbar>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
              />
              <DxColumn
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
              >
              </DxColumn>

              <DxColumn data-field="golongan_id" caption="Gol.Baru">
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn data-field="riwayatGolongan.golongan_id" caption="Gol.">
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="pegawai.status_ptkp"
                caption="Status PTKP"
              />
              <DxColumn
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatPekerjaan.seksi_id" caption="Seksi">
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" />
              <DxColumn
                data-field="pot_5_persen"
                caption="Pot. 5 Persen"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_pensiun"
                caption="Pot. Pensiun Jiwasraya"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
              />
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
            </DxDataGrid>
          </template>
          <template #tHonor>
            <DxDataGrid
              ref="gridRefHonor"
              id="gridHonor"
              :data-source="dataSourceHonor"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefHonor')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem name="exportButton" />
              </DxToolbar>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
              />
              <DxColumn
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
              >
              </DxColumn>

              <DxColumn data-field="riwayatGolongan.golongan_id" caption="Gol.">
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatGolongan.jabatan_id" caption="Gol.">
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatPekerjaan.seksi_id" caption="Seksi">
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="riwayatGolongan.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
              />

              <DxColumn
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn>
              <DxColumn
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
              />
              <DxColumn
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
              />

              <DxColumn
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" />
              <DxColumn
                data-field="pot_5_persen"
                caption="Pot. 5%"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_bpjs_tk_dua_persen"
                caption="Pot. BPJS TK 2%"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
              />
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_dua_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
            </DxDataGrid>
          </template>
          <template #tKontrak>
            <DxDataGrid
              ref="gridRefKontrak"
              :data-source="dataSourceKontrak"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefKontrak')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />
              <DxToolbar>
                <DxItem name="exportButton" />
              </DxToolbar>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
              >
              </DxColumn>
              <DxColumn data-field="riwayatGolongan.golongan_id" caption="Gol.">
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn>
              <DxColumn data-field="riwayatGolongan.jabatan_id" caption="Gol.">
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatPekerjaan.seksi_id" caption="Seksi">
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-field="riwayatGolongan.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
              />

              <DxColumn
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" />
              <DxColumn
                data-field="pot_5_persen"
                caption="Pot. 5%"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
                caption="Tunj. BPJS TK 1.19%"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
                caption="Pot. BPJS TK 1.19%"
                cell-template="currencyTemplate"
              />
              <DxColumn
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
              />
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>
              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
            </DxDataGrid>
          </template>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxTabPanel from "devextreme-vue/tab-panel";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DateTime } from "luxon";
import _ from "lodash";
const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 4,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
];

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}

function convertFilter(filter, regVar) {
  // const regex = new RegExp(`${regVar}\/(\\w+) eq (\\d+)`, "g"); //utk detect riwayatPekerjaan/cabang_id eq 2
  const regex = new RegExp(`${regVar}/(\\w+) eq (\\d+)`, "g");
  const outputString = filter.replace(regex, (match, p1, p2) => {
    return `${regVar}/any(s:s/${p1} eq ${p2})`;
  });
  return outputString;
}

const dataSourceDireksi = new DataSource({
  store: new ODataStore({
    url: "http://127.0.0.1/odata/PegawaiGajiFinals",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,riwayatGolongan,pegawai"],
  filter: [
    ["gaji_skema_id", 4],
    "or",
    ["gaji_skema_id", 5],
    "or",
    ["gaji_skema_id", 6],
  ], //FIXME: kemgunkinan error, karena pegawai direksi bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = direksi dari riwayatPekerjaan
});

const dataSourceTetap = new DataSource({
  store: new ODataStore({
    url: "http://127.0.0.1/odata/PegawaiGajiFinals",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,riwayatGolongan,pegawai"],
  filter: ["gaji_skema_id", 3], //FIXME: kemgunkinan error, karena pegawai tetap bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = tetap dari riwayatPekerjaan
});

const dataSourceHonor = new DataSource({
  store: new ODataStore({
    url: "http://127.0.0.1/odata/PegawaiGajiFinals",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,riwayatGolongan,pegawai"],
  filter: ["gaji_skema_id", 1], //FIXME: kemgunkinan error, karena pekerja honor bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = honor dari riwayatPekerjaan
});

const dataSourceKontrak = new DataSource({
  store: new ODataStore({
    url: "http://127.0.0.1/odata/PegawaiGajiFinals",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,riwayatGolongan,pegawai"],
  filter: ["gaji_skema_id", 2], //FIXME: kemgunkinan error, karena Pekerja kontrak bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = kontrak dari riwayatPekerjaan
});

export default {
  components: {
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      jabatanSource: new ODataStore({
        url: "http://127.0.0.1/odata/Jabatans",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      subBidangSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBidangs",
        key: "id",
      }),
      pegawaiGajiDetailSource: new ODataStore({
        url: "http://127.0.0.1/odata/PegawaiGajiDetails",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      pegawaiSource: new ODataStore({
        url: "http://127.0.0.1/odata/SimpegPegawais",
        key: "id",
        version: 4,
        beforeSend: function (e) {
          e.headers = {
            "odata-version": "4.0",
          };
        },
      }),
      numberingPageSize: 20,
      numberingPageNumber: 0,
      dataSourceTetap: dataSourceTetap,
      dataSourceHonor: dataSourceHonor,
      dataSourceKontrak: dataSourceKontrak,
      dataSourceDireksi: dataSourceDireksi,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      filterValue: "",

      oneditorpreparing: function (e) {
        if (e.dataField === "tgl_gaji") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      calculateFilterMK: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        if (selectedFilterOperation === "contains" && target == "filterRow") {
          const currentDate = DateTime.now();
          const mkDate = currentDate.minus({ years: filterValue });
          var filterExpression = [
            "year(" +
              this.dataField +
              ") ge " +
              mkDate.year +
              " and " +
              "year(" +
              this.dataField +
              ") le " +
              currentDate.year,
          ];
          return filterExpression;
        }
      },
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(" +
              column.dataField +
              ") lt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(" +
              column.dataField +
              ") gt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(" +
              column.dataField +
              ") ge " +
              bulan1 +
              " and year(" +
              column.dataField +
              ") ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(" +
              column.dataField +
              ") le " +
              bulan2 +
              " and year(" +
              column.dataField +
              ") le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
    };
  },
  mounted() {},
  methods: {
    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    calculateDisplayMK(e) {
      // const today = DateTime.local().setLocale("id"); //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const today = DateTime.fromISO(e.tgl_gaji);
      const date2 = DateTime.fromISO(e.riwayatGolongan.tgl_mulai_bekerja);
      return Math.floor(today.diff(date2, "years").years) + " tahun";
    },
    formatMasaKerja(e) {
      const today = DateTime.local().setLocale("id"); //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const date2 = DateTime.fromISO(e);
      return Math.floor(today.diff(date2, "years").years);
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");

      return date.monthLong + " " + date.year;
    },
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji " + this.tabSource[this.tabPanelIndex].text + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
